
/**
 * 资源加载类
 */
 import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';

 let font = null;
 const fontLoader = new FontLoader();
 /***
  * 预先加载模型；字体；等资源；
  */
 export const loadPublicResource = () => {
     Promise.resolve().then(() => {
         initFont()
     })
 }
 
 export const initFont = () => {
     fontLoader.load('fonts/helvetiker_regular.typeface.json', function (eFont) {
         font = eFont;
     });
 }